import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import cookie from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { getAnalytics as _getAnalytics } from '@miro-site/analytics';
import { jsx as _jsx } from "react/jsx-runtime";
var anonymousIdInterval;
var STATUSES;

(function (STATUSES) {
  STATUSES["loading"] = "loading";
  STATUSES["ready"] = "READY";
  STATUSES["error"] = "ERROR";
})(STATUSES || (STATUSES = {}));

var initialValue = {
  status: STATUSES.loading,
  isLoading: true
};
var SplitIoContext = /*#__PURE__*/React.createContext([initialValue, null]);
export var SplitIoProvider = function SplitIoProvider(props) {
  var children = props.children,
      _props$getAnalytics = props.getAnalytics,
      getAnalytics = _props$getAnalytics === void 0 ? _getAnalytics : _props$getAnalytics,
      _props$authorizationK = props.authorizationKey,
      authorizationKey = _props$authorizationK === void 0 ? process.env.NEXT_PUBLIC_SPLITIO_CLIENT_KEY : _props$authorizationK,
      _props$triesLimit = props.triesLimit,
      triesLimit = _props$triesLimit === void 0 ? 20 : _props$triesLimit;

  var _useState = useState(initialValue),
      splitIOState = _useState[0],
      setSplitIOState = _useState[1];

  var _useState2 = useState(null),
      client = _useState2[0],
      setClient = _useState2[1];

  function isBot() {
    var userAgent = navigator.userAgent;
    var regexp = /bot|crawl|slurp|spider|mediapartners|go-http-client|apache|axios|ahc/i;
    return !!(userAgent && userAgent.match(regexp));
  }

  useEffect(function () {
    if (isBot()) {
      setSplitIOState({
        status: STATUSES.error,
        error: 'Crawler / bot detected'
      });
    } else {
      setSplitIOState({
        status: STATUSES.loading,
        error: ''
      });
      var tries = 0;
      anonymousIdInterval = window.setInterval(function () {
        if (tries >= triesLimit) {
          setSplitIOState({
            status: STATUSES.error,
            error: "Id cookie wasn't found"
          });
          clearInterval(anonymousIdInterval);
          return;
        }

        var anonymousId = cookie.get('ajs_anonymous_id');

        if (typeof anonymousId === 'string' && anonymousId.length) {
          clearInterval(anonymousIdInterval);
          initSplitIo(anonymousId.replace(/"/g, ''));
        }

        tries++;
      }, 50);
    }

    function initSplitIo(_x) {
      return _initSplitIo.apply(this, arguments);
    }

    function _initSplitIo() {
      _initSplitIo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(anonymousId) {
        var analytics;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                analytics = getAnalytics();
                _context2.next = 8;
                break;

              case 4:
                _context2.prev = 4;
                _context2.t0 = _context2["catch"](0);
                setSplitIOState({
                  status: STATUSES.error,
                  error: "Analytics library wasn't initialized"
                });
                return _context2.abrupt("return");

              case 8:
                _context2.next = 10;
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var ExperimentationClient, experimentation;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!window.split) {
                            _context.next = 2;
                            break;
                          }

                          return _context.abrupt("return");

                        case 2:
                          _context.next = 4;
                          return import('@mirohq-internal/experimentation-core');

                        case 4:
                          ExperimentationClient = _context.sent.ExperimentationClient;
                          experimentation = new ExperimentationClient();
                          _context.prev = 6;
                          _context.next = 9;
                          return experimentation.initFactory({
                            config: {
                              authorizationKey: authorizationKey,
                              traffic: {
                                defaultTrafficType: 'anonymous_user',
                                anonymousUserKey: anonymousId
                              },
                              analytics: {
                                sendEvent: function sendEvent() {
                                  var _analytics;

                                  return (_analytics = analytics).sendCustomEvent.apply(_analytics, arguments);
                                }
                              }
                            },
                            advancedSettings: {
                              storage: {
                                type: 'MEMORY'
                              }
                            }
                          });

                        case 9:
                          _context.next = 11;
                          return experimentation.getClient().ready();

                        case 11:
                          setSplitIOState({
                            status: STATUSES.ready,
                            error: ''
                          });
                          setClient(experimentation);
                          _context.next = 19;
                          break;

                        case 15:
                          _context.prev = 15;
                          _context.t0 = _context["catch"](6);
                          setSplitIOState({
                            status: STATUSES.error,
                            error: "Experimentation Client wasn't initialized"
                          });
                          setClient(experimentation);

                        case 19:
                          window.split = experimentation;

                        case 20:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[6, 15]]);
                }))();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 4]]);
      }));
      return _initSplitIo.apply(this, arguments);
    }
  }, []);
  return /*#__PURE__*/_jsx(SplitIoContext.Provider, {
    value: [_objectSpread(_objectSpread({}, splitIOState), {}, {
      isLoading: splitIOState.status == STATUSES.loading
    }), client],
    children: children
  });
};
export var useSplitIo = function useSplitIo() {
  return React.useContext(SplitIoContext);
};
export var useTreatment = function useTreatment(name, attrs) {
  var _getMockTreatment;

  var _useSplitIo = useSplitIo(),
      _useSplitIo2 = _slicedToArray(_useSplitIo, 2),
      isLoading = _useSplitIo2[0].isLoading,
      client = _useSplitIo2[1];

  var _useState3 = useState({}),
      mockTreatments = _useState3[0],
      setMockTreatments = _useState3[1];

  useEffect(function () {
    var getMockTreatmentsFromUrl = function getMockTreatmentsFromUrl() {
      var _location;

      var treatments = {};
      var treatmentPrefix = 'split_exp_';

      if ((_location = location) !== null && _location !== void 0 && _location.search) {
        var searchParams = new URLSearchParams(location.search);
        searchParams.forEach(function (value, param) {
          if (param.startsWith(treatmentPrefix)) {
            var key = param.slice(treatmentPrefix.length);
            treatments[key] = value;
          }
        });
        setMockTreatments(treatments);
      }
    };

    if (true) {
      getMockTreatmentsFromUrl();
    }
  }, []);

  var getMockTreatment = function getMockTreatment(name) {
    return mockTreatments[name];
  };

  var treatment = (_getMockTreatment = getMockTreatment(name)) !== null && _getMockTreatment !== void 0 ? _getMockTreatment : client === null || client === void 0 ? void 0 : client.getTreatment(name, attrs);
  return [treatment, isLoading];
};